/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component, cloneElement } from 'react';
import { Overlay, Popover } from 'react-bootstrap';
import _ from 'lodash';
import ShortLinkAPI from 'edrolo/api/ShortLink';

function getUtmQueryStringParams(utm_campaign, utm_referrer) {
  utm_referrer = typeof utm_referrer !== 'undefined' ? utm_referrer : 'unknown';
  return {
    utm_source: 'edrolo',
    utm_medium: 'sharelink',
    utm_campaign,
    utm_referrer,
  };
}

class ShareLinkPopover extends Component {
  static defaultProps = {
    title: 'Copy and paste this link:',
  };

  state = {
    shortLink: null,
  };

  componentDidMount() {
    const { queryString, hash, appLabel, model, objectId } = this.props;

    ShortLinkAPI.create(
      appLabel,
      model,
      objectId,
      hash ? queryString + hash : queryString
    ).then(this.handleShortLinkCreated);
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.shortLink && this.state.shortLink) {
      this.input.focus();
      this.input.select();
    }
  }

  handleShortLinkCreated = (result) => {
    this.setState({
      shortLink: ((result || {}).body || {}).share_url,
    });
  };

  render() {
    return (
      <div className="share-link-container">
        <h5>{this.props.title}</h5>
        {!this.state.shortLink ? (
          <span>Generating share link...</span>
        ) : (
          <span>
            <input
              ref={(c) => (this.input = c)}
              value={this.state.shortLink}
              readOnly
            />
            <p>Press Ctrl+C or &#8984;+C to copy</p>
          </span>
        )}
      </div>
    );
  }
}

// eslint-disable-next-line  react/no-multi-comp
class ShareLink extends Component {
  state = { isOpen: false };

  open = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ isOpen: true });

    analytics.track('clicked share link', {
      origin: this.props.origin,
      app: this.props.appLabel,
      model: this.props.model,
      object_id: this.props.objectId,
      class_id: this.props.classId,
    });
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  renderOpen() {
    const utmQueryStringParams = this.props.utm_campaign
      ? getUtmQueryStringParams(
          this.props.utm_campaign,
          this.props.userId || global.reactUserId
        )
      : {};

    const searchParams = new URLSearchParams({
      ...this.props.queryStringParams,
      ...utmQueryStringParams,
    });

    const queryString = `?${searchParams.toString()}`;

    return (
      <Overlay
        show
        rootClose
        placement={this.props.placement}
        onHide={this.close}
        target={this.targetElement}
      >
        <Popover id={_.uniqueId()} className="share-link-popover">
          <ShareLinkPopover
            title={this.props.title}
            appLabel={this.props.appLabel}
            model={this.props.model}
            objectId={this.props.objectId}
            queryString={queryString}
            hash={this.props.hash}
          />
        </Popover>
      </Overlay>
    );
  }

  render() {
    let trigger;

    if (this.props.children) {
      trigger = cloneElement(this.props.children, {
        onClick: this.open,
      });
    } else {
      trigger = (
        <a className={`share-${this.props.shareType}`} onClick={this.open}>
          Share link
        </a>
      );
    }

    return (
      <span
        style={{ position: 'relative' }}
        ref={(c) => (this.targetElement = c)}
        data-test="share-link"
      >
        {this.state.isOpen && this.renderOpen()}
        {trigger}
      </span>
    );
  }
}

ShareLink.propTypes = {
  origin: PropTypes.string.isRequired,
};

ShareLink.defaultProps = {
  appLabel: 'tod',
  shareType: 'exam',
  placement: 'bottom',
  queryStringParams: {},
};

export default ShareLink;
